import { Input, Modal, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import Button from "../common/Button";
import TextArea from "antd/es/input/TextArea";
import { apiEditWorkItem } from "../../services/WorkItem";
import { ToastFailed, ToastSuccess } from "../common/Toast";
import { onBlurInputFormData } from "../../helps/InputData";

export default ({ setPageIndex, isModalOpen, dataDetail, setIsModalOpen, handleGetListWorkItems }) => {
    const [formData, setFormData] = useState({ ...dataDetail })
    const [errors, setErrors] = useState({
        name: "",
        unit: "",
    });

    const handleCancel = () => {
        setIsModalOpen(false);
        setFormData({})
        setErrors({
            name: "",
            unit: "",
        })
    };

    useEffect(() => {
        if (isModalOpen) {
            setFormData({ ...dataDetail })
        }
    }, [isModalOpen, dataDetail])

    const handleChangeInput = (e, name) => {
        const newFormData = { ...formData };
        newFormData[name] = e.target.value
        setFormData(newFormData)
        setErrors({ ...errors, [name]: "" })
    }

    const handleEditWorkItem = async () => {
        const newErrors = {
            name: formData.name.trim() ? "" : "Name is required field.",
            unit: formData.unit.trim() ? "" : "Unit is required field.",
        };
        setErrors(newErrors);
        if (!formData.name || !formData.unit) {
            return
        }

        try {
            const response = await apiEditWorkItem({ ...formData, name: formData.name.trim(), unit: formData.unit.trim(), remark: formData.remark.trim() })
            if (response?.header?.resultCode === "1000") {
                handleGetListWorkItems()
                handleCancel()
                setPageIndex(1)
                ToastSuccess("The update has been successful")
            }
        } catch (error) {
            if (error.response) {
                // Access the response object in the error
                if (error.response.data.header?.message?.includes("is exist.")) {
                    setErrors({ ...errors, name: "The work item name already exists in the system; please choose a different name." })
                    ToastFailed("The work item name already exists in the system; please choose a different name.");
                } else {
                    ToastFailed("The work item update has failed.")
                }
            } else {
                // Handle other unexpected errors
                ToastFailed("The work item update has failed.")
            }
        }
    }

    return (
        <Modal title={"Edit work item"} open={isModalOpen} footer={null} className='modal-add-new'>
            <div className="add-new-data">
                <div>
                    <div className="d-flex gap-2">
                        <label>Name <span className="text-danger ms-1">*</span></label>
                        <Input
                            value={formData.name}
                            placeholder="Input name"
                            className={`${errors.name ? 'input-error' : ''} w-100`}
                            onChange={(e) => handleChangeInput(e, "name")}
                            onBlur={() => onBlurInputFormData({ formData, setFormData, field: "name" })}
                            maxLength={50} />
                    </div>
                    {errors.name && <div className="text-danger text-error">{errors.name}</div>}
                </div>
                <div>
                    <div className="d-flex gap-2">
                        <label>Unit <span className="text-danger ms-1">*</span></label>
                        <Input
                            placeholder="Input unit"
                            value={formData.unit}
                            onChange={(e) => handleChangeInput(e, "unit")}
                            onBlur={() => onBlurInputFormData({ formData, setFormData, field: "unit" })}
                            className={`${errors.unit ? 'input-error' : ''} w-100`}
                            maxLength={30} />
                    </div>
                    {errors.unit && <div className="text-danger text-error">{errors.unit}</div>}
                </div>
                <div className="d-flex gap-2">
                    <label className="remark">Remark</label>
                    <TextArea rows={3}
                        placeholder="Input remark"
                        value={formData.remark}
                        onChange={(e) => handleChangeInput(e, "remark")}
                        onBlur={() => onBlurInputFormData({ formData, setFormData, field: "remark" })}
                        maxLength={500} />
                </div>
            </div>
            <div className="modal-add-new_footer">
                <Popconfirm
                    title="This change will be reflected in all the data. Are you sure you want to commit it?"
                    okText="Confirm"
                    cancelText="Cancel"
                    onConfirm={handleEditWorkItem}
                >
                    <button className="button-save">Save</button>
                </Popconfirm>
                <Button title={"Cancel"} BgColor={"#fff"} fontColor={"#000000D9"} borderColor={"#D9D9D9"} handleClick={handleCancel} width={"75px"} />
            </div>
        </Modal>
    );
};
